Ext.define('SA.view.sidebar.data.DataFacetRange', {
    alias: 'widget.data-search-range',
    extend: 'SA.view.SimpleContainer',

    baseCls: 'sa-sidebar-data-range',

    initComponent() {
        var inputMask = this.inputMask,
            inputFormat = this.inputFormat,
            maxInputLength = this.maxInputLength,
            maxValue = this.maxValue;

        this.items = [
            {
                xtype: 'component',
                cls: 'sa-sidebar-data-range-title',
                html: this.title
            }, {
                xtype: 'simple-container',
                cls: 'sa-sidebar-data-range-body',

                items: [
                    {
                        xtype: 'simple-container',
                        cls: 'sa-sidebar-data-range-field-row',

                        items: [
                            {
                                xtype: 'sa-formatted-numberfield',
                                cls: 'sa-sidebar-data-range-field',
                                format: formatValue,
                                itemId: 'minimum',
                                maskRe: inputMask,
                                maxLength: maxInputLength,
                                maxValue
                            }, {
                                xtype: 'sa-formatted-numberfield',
                                cls: 'sa-sidebar-data-range-field',
                                format: formatValue,
                                itemId: 'maximum',
                                maskRe: inputMask,
                                maxLength: maxInputLength,
                                maxValue
                            }
                        ]
                    }, {
                        xtype: 'range-slider',
                        formatLabel: this.formatLabel,
                        itemId: 'slider',
                        labelIncrement: this.labelIncrement,
                        limits: this.limits,
                        stepIncrement: this.stepIncrement,
                        tickIncrement: this.tickIncrement
                    }
                ]
            }
        ];

        this.callParent();

        this.minField = this.down('#minimum');
        this.maxField = this.down('#maximum');
        this.slider = this.down('#slider');

        this.minField.on('change', this.onFieldChange, this);
        this.maxField.on('change', this.onFieldChange, this);
        this.slider.on('interactiondone', this.onSliderInteractionDone, this);

        this.triggerChangeBuffered = SA.createBuffered(this.triggerChange, 500);

        function formatValue(value) {
            return SA.formatValue(value, inputFormat);
        }
    },

    clear() {
        this.setMinMax([null, null]);

        this.onFieldChange();
    },

    getMinMax() {
        return [this.minField.getValue(), this.maxField.getValue()];
    },

    onFieldChange() {
        if (this.ignoreFieldChange) {
            return;
        }

        this.slider.setMinMax(this.getMinMax());

        this.triggerChangeBuffered();
    },

    onSliderInteractionDone(sliderMinMax) {
        var currentMinMax = this.getMinMax(),
            limits = this.limits,
            minChanged = didChange(currentMinMax[0], sliderMinMax[0], limits[0]),
            maxChanged = didChange(currentMinMax[1], sliderMinMax[1], limits[1]);

        if (minChanged || maxChanged) {
            this.setMinMax(sliderMinMax);

            this.triggerChange();
        }

        function didChange(currentValue, handleValue, limitValue) {
            return !(currentValue === handleValue || (currentValue === null && handleValue === limitValue));
        }
    },

    setMinMax(minMax) {
        this.ignoreFieldChange = true;

        this.minField.setValue(minMax[0]);
        this.maxField.setValue(minMax[1]);

        this.ignoreFieldChange = false;
    },

    triggerChange() {
        this.fireEvent('change', this.getMinMax());
    }
});